export const LogoMark = ({ className = "h-9 w-auto" }) => (
  <svg viewBox="0 0 250 72" className={className} fill="none" aria-hidden="true">
    <path
      d="M18 50 C23 39 41 32 66 28 L87 25 C101 15 121 9 144 9 C169 9 188 17 202 26 L216 29 C232 32 242 39 244 46 C245 49 243 50 239 50 L18 50 Z"
      fill="currentColor"
    />
    <path
      d="M97 26 C109 18 125 14 142 14 C160 14 175 20 187 27 L150 28 Z"
      fill="#0b0d10"
      opacity="0.9"
    />
    <path
      d="M26 44 C90 41 180 41 236 44"
      stroke="#e63329"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <circle cx="88" cy="52" r="13" fill="#0b0d10" stroke="#e63329" strokeWidth="4" />
    <circle cx="88" cy="52" r="4.5" fill="#e63329" />
    <circle cx="200" cy="52" r="13" fill="#0b0d10" stroke="#e63329" strokeWidth="4" />
    <circle cx="200" cy="52" r="4.5" fill="#e63329" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center" data-testid="brand-logo">
    <img
      src="/logo.png"
      alt="MECA AUTO CLEAN 01 — Diagnostique, réparation, entretien"
      className={
        compact
          ? "h-10 w-auto rounded-md bg-white px-2.5 py-1 transition-shadow duration-300 hover:shadow-[0_0_18px_rgba(230,51,41,0.4)]"
          : "h-14 w-auto rounded-md bg-white px-3 py-1.5 transition-shadow duration-300 hover:shadow-[0_0_18px_rgba(230,51,41,0.4)]"
      }
    />
  </span>
);
